import { ColorPicker } from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input } from 'antd'
import { useEffect } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectSelectedFormQuestionOption } from '../../../../store/membership/FormQuestionOptionReducer'
import { requiredRule } from '../../../../utils/rules'
import AttachmentEditor from '../../../AttachmentEditor'
import { Localizable } from '../../../localizable/Localizable'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedFormQuestionOption())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="id"
        hidden
        style={{ display: 'none' }}
        rules={[]}
        noStyle
      >
        <Input type="hidden" />
      </Form.Item>
      <Localizable.Input
        name="label"
        rules={[requiredRule()]}
        label={'Label'}
        max={45}
      />
      <Localizable.Input name="description" label={'Description'} max={70} />

      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>

      <AttachmentEditor
        formItem={{ name: 'picture', rules: [requiredRule()] }}
        dragger={{ fileTypes: ['picture'] }}
        image={{ width: 512, height: 512, aspect: 1 }}
      />
    </Form>
  )
}

export default Update
